const { ActionTypes } = require("../constants/action_types");

const initialState = { cohortData: "", activeIndex: 0, chekClick: "" };

export const cohortReducer = (state = initialState, { type, payload }) => {

    switch (type) {
        case ActionTypes.COHORT_DATA:
            return payload;
        default:
            return state;
    }
};